<template>
  <div class="dynamic-wrapper">
    <div class="dynamic-list-container" v-if="lists.length > 0" style="padding-bottom:1px;">
      <div class="grid__item-dynamic" v-for="(dynamic, index) in lists" :key="index" :class="{
        'scroll-up-to': !isDetail,
        '--detail-type': isDetail
      }">
        <div class="item__wrapper">
          <template v-if="$isMobile">
            <div class="dy-header-container">
              <div class="header__user-info">
                <div class="info__headpic">
                  <img :src="dynamic.userDetail.avatar" alt="" />
                </div>
                <p class="info__name">{{ dynamic.userDetail.nickname }}</p>
              </div>
              <div class="header__publish">{{ dynamic.ctime | parseTime }}</div>
            </div>
            <div class="dy-main-body-container">
              <div class="main-body__content">{{ dynamic.content }}</div>
              <div class="main-body__pics" v-if="dynamic.picture_urls.length > 0">
                <div class="pics__wrapper">
                  <div class="pic__item" v-for="(img, p) in dynamic.picture_urls" :key="p">
                    <el-image class="img" :src="img | parseImage"
                      :preview-src-list="dynamic.picture_urls | parseImage"></el-image>
                  </div>
                </div>
              </div>
            </div>
            <div class="dy-reply-form-container">
              <div class="reply-list-header">
                <div class="list__item">
                  <p>评论 {{ dynamic.commentNum }}</p>
                </div>
                <div class="list__item">
                  <i class="icon icon-heart view__icon"></i>
                  <p>{{ dynamic.likenums }}</p>
                </div>
              </div>
              <div class="reply-list-main-body" v-if="dynamic.commentList.length > 0">
                <div class="reply__item" v-for="(reply, r) in dynamic.commentList" :key="r">
                  <div class="item__head">
                    <img :src="reply.user_avatar" alt="" />
                  </div>
                  <div class="r-item__content">
                    <div class="content__name">{{ reply.user_name }}</div>
                    <div class="content__text">{{ reply.content }}</div>
                    <div class="content__publish">{{ reply.ctime | parseTime }}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="item__head-pic" @click="
              gojump(dynamic.user_id, dynamic.userDetail.is_store, dynamic.userDetail.store_id)
              " :data-userid="dynamic.user_id">
              <img :src="dynamic && dynamic.userDetail.avatar" alt="" />
            </div>
            <div class="item__content">
              <div class="content__text">{{ dynamic.content }}</div>
              <div class="content__like-counts --actived">
                <i class="like__icon icon icon-like --actived"></i>
                <p class="like__count">{{ dynamic.likenums }}</p>
              </div>
            </div>
            <div class="item__images-container" v-if="dynamic.picture_urls.length > 0">
              <div class="images-container__wrapper">
                <div class="images__item hoverEffect" v-for="(img, i) in dynamic.picture_urls" :key="i">
                  <div class="images__item__wrapper">
                    <el-image class="img" :src="img | parseImage"
                      :preview-src-list="dynamic.picture_urls | parseImage"></el-image>
                  </div>
                </div>
              </div>
            </div>
            <div class="item__base-info">
              <div class="info__author-name">{{ dynamic.userDetail.nickname }}</div>
              <div class="info__publish">{{ dynamic.ctime | parseTime }}</div>
            </div>
            <div class="item__reply-form">
              <div class="form__textarea">
                <textarea :autofocus="false" placeholder="在这里你可以说些什么" v-model="reply[dynamic.id]"></textarea>
              </div>
              <el-button class="form__submit" @click="onSubmit" :loading="loading[dynamic.id]"
                :data-id="dynamic.id">评论</el-button>
            </div>
            <div class="item__replies-container" v-if="dynamic.commentList.length > 0" :class="{
              isDetail: isDetail
            }">
              <div class="replies__item" v-for="(reply, r) in dynamic.commentList" :key="r"
                @click="isDetail && delReply(reply.id)">
                <i v-if="isDetail" class="el-icon-close icon"></i>
                <div class="item__headpic" :style="{
                  backgroundImage: `url(${reply.user_avatar})`
                }" @click="gojump(reply.user_id, reply.is_store, reply.store_id)"></div>
                <div class="item__info">
                  <div class="info__replier">
                    <div class="replier__name">{{ reply.user_name }}</div>
                    <div class="replier__publish">{{ reply.ctime | parseTime }}</div>
                  </div>
                  <div class="info__reply-content">{{ reply.content }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <Empty hint="没有找到相关信息" v-else></Empty>
    <Pagination class="component-pagination" :config="isShowPagination" v-if="isShowPagination && lists.length > 0">
    </Pagination>
  </div>
</template>

<script>
import Pagination from '@/components/pagination.vue';
import Empty from '@/pages/common/empty.vue';
import { handlerReply } from '@/assets/utils/handler';

export default {
  components: {
    Pagination,
    Empty,
  },
  props: {
    dynamics: {
      type: Array,
      default: () => [],
    },
    isShowPagination: {
      type: Object,
      default: null,
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
      reply: {},
      loading: {},
      request: false,
    };
  },
  watch: {
    dynamics: {
      handler(val) {
        this.lists = val
          ? val.map((item) => {
            const temp = item;
            this.$set(this.reply, item.id, '');
            this.$set(this.loading, item.id, false);
            return temp;
          })
          : [];
      },
      immediate: true,
    },
  },
  mounted() {
    console.log(this.lists);
  },
  methods: {
    onSubmit(e) {
      const that = this;
      const target = e.currentTarget;
      const { id } = target.dataset;
      const reply = that.reply[id];
      that.$set(that.loading, id, true);

      handlerReply(id, reply)
        .then((res) => {
          this.$message({
            type: 'success',
            message: '评论成功',
          });
          that.lists.map((item) => {
            const temp = item;
            if (Number(temp.id) === Number(id)) {
              temp.commentList.unshift(res.data);
            }
            return temp;
          });
          that.$set(that.reply, id, '');
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          that.$set(that.loading, id, false);
        });
    },
    gojump(uid, isStore, storeId) {
      if (uid > 0) {
        if (Number(isStore) === 1) {
          // 跳转商户
          this.$router.push({
            path: `/merchant/${storeId}/cases`,
          });
        } else {
          // 跳转用户中心
          this.$router.push({
            path: `/member/${uid}`,
          });
        }
      } else {
        this.$message({
          type: 'info',
          message: '该用户为电子用户，不存个人中心',
        });
      }
    },
    delReply(rid) {
      const that = this;
      console.log(rid);
      if (rid === -1) {
        that.$message({
          type: 'warning',
          message: '请刷新之后再进行操作',
        });
        return;
      }
      that.$confirm('是否删除此条回复', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          const tempInstance = instance;
          if (action === 'confirm') {
            tempInstance.confirmButtonLoading = true;
            tempInstance.confirmButtonText = '删除中...';
            that.$http
              .post('html/Dynamic/commentDel', {
                id: rid,
              })
              .then(() => {
                tempInstance.confirmButtonLoading = false;
                that.$message({
                  type: 'success',
                  message: '删除成功',
                });
                that.lists['0'].commentList = that.lists['0'].commentList.filter(
                  (item) => Number(item.id) !== Number(rid),
                );
                done();
              });
          } else {
            done();
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_mixin";

.component-pagination {
  margin-top: px2vw(98 - 20);
}
</style>
